import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { usuario, UsuarioState } from './usuarioStore';
import { sugestaoResposta, SugestaoRespostaState } from './sugestaoRespostaStore';
import quadroPersonalizadoStore, { QuadroPersonalizadoStateType } from './quadroPersonalizadoStore';
import storeLayout, { EstadoLayout } from './layoutStore';

Vue.use(Vuex);

export interface RootState {
  usuario: UsuarioState;
  sugestaoResposta: SugestaoRespostaState;
  quadroPersonalizado: QuadroPersonalizadoStateType;
  layout: EstadoLayout;
}

const storeOptions: StoreOptions<RootState> = {
  modules: {
    usuario,
    sugestaoResposta,
    quadroPersonalizado: quadroPersonalizadoStore,
    layout: storeLayout,
  },
};

const store = new Vuex.Store<RootState>(storeOptions);


export default store;
